import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 08:56
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";

/**
 * Visual component to show a quest accept dialog if offer reach offer quest pending state
 */
export class OfferDescriptionVisualQuestAcceptDialog implements IOfferDescriptionVisualParameter {
    private _dialogName: string;
    private _autoShow: boolean = false;

    constructor(dialogName: string, autoShow: boolean = true) {
        this._dialogName = dialogName;
        this._autoShow = autoShow;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_QUEST_ACCEPT_DIALOG;
    }

    public parseFromObjectParam(params: any): void {
        this._dialogName = params.DN;

        if (params.AS != null) {
            this._autoShow = params.AS;
        }
        else {
            this._autoShow = true;
        }
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // show quest accept dialog with registered dialog name
        // OVERRIDE TO EXECUTE DIALOGHANDLER
        //BasicDialogHandler.getInstance().registerDialogs(_dialogName, new BasicPrivateOfferDialogProperties(offerVO));
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return state === PrivateOfferStateEnum.QUEST_PENDING;
    }

    public get dialogName(): string {
        return this._dialogName;
    }

    public get autoShow(): boolean {
        return this._autoShow;
    }

    public dispose(): void {
        this._dialogName = null;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_VISUAL_ACCEPT_DIALOG";
    }
}

